import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IPuntoCampionamento } from 'src/app/modules/punti-campionamento/punti-campionamento.model';
import { InputDatetimeComponent } from 'src/app/shared/components/inputs/input-datetime/input-datetime.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';

@Component({
  selector: 'app-analisi-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextComponent,
    InputDatetimeComponent,
  ],
  templateUrl: './analisi-form.component.html',
  styleUrl: './analisi-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalisiFormComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() prelievoData?:FormGroup;
  checkPrelievoData = ''
  constructor(private cdr : ChangeDetectorRef){}
  ngOnInit() {
    this.form.addControl('numeroRapportoProvaAnalisi', new FormControl('', [Validators.required]));
    this.form.addControl('dataOraAnalisi', new FormControl(null, [Validators.required]));
    this.form.addControl('codiceAccrediaLaboratorioAnalisi', new FormControl('', [Validators.required]));

    this.prelievoData?.valueChanges.subscribe(val=>{
      if(val.dataOraPrelievo && typeof val.dataOraPrelievo == "string"){
          console.log(val.dataOraPrelievo)
          this.checkPrelievoData=`${val.dataOraPrelievo}`
          this.cdr.detectChanges()
      }

    })
  }
}
